import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { IconProps } from 'react-feather';
import { AiOutlineFileSearch } from 'react-icons/ai';

type Props = {
  onClick?: () => void;
  iconProps?: IconProps;
  disabled?: boolean;
  popoverContent?: React.ReactNode;
  placement?: TooltipPlacement;
};

const SearchFileIcon: React.FC<Props> = ({
  onClick,
  iconProps,
  disabled,
  popoverContent,
  placement,
}) => {
  return (
    <Popover content={popoverContent} placement={placement}>
      <AiOutlineFileSearch
        style={disabled ? { cursor: 'not-allowed' } : {}}
        size={20}
        cursor={'pointer'}
        onClick={!disabled ? onClick : undefined}
        {...iconProps}
      />
    </Popover>
  );
};

export default SearchFileIcon;
